import React, { useRef, useEffect, useState } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '../../../atoms/comments/card-header';
import CommentCardHeader from '@material-ui/core/CardContent';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import styles from './styles.scss';
import AvatarCustom from '../../../atoms/avatar/AvatarCustom';
import { inIframe } from '../../../../utils/iframe-utils';
import Utils from '../../../../utils/comments-utils';
import { CardProps } from '../../../../utils/comments/types';
import LongCommentPopover from '../../../molecules/comments/longcomment-popover';

/* CommentCard displays a single comment card */
const CommentCard = function CommentCard(
    { comment, pageUrl, targetName, avatarSrc, isMobile = false, }: CardProps
) {
    const [showPopOver, setShowPopOver] = useState(false);
    const cardRef = useRef<HTMLDivElement>(null);

    const [isTruncated, setIsTruncated] = useState(false);
    const messageTextRef = useRef<HTMLDivElement>(null);

    const checkTextOverflow = () => {
        if (!messageTextRef.current) {
            return false;
        }

        const e = messageTextRef.current.getElementsByTagName('p')[0];
        return Boolean(e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth);
    }

    const canExpand = comment.Reply || isTruncated;

    useEffect(() => {
        setIsTruncated(checkTextOverflow());
    }, []);

    return (
        <>
            <div className={styles.commentcard}>
                <div
                    className={`${canExpand ? styles.pointer : ''} ${styles['card-container']}`}
                    onClick={() => {
                        console.log(canExpand);
                        if (canExpand) {
                            setShowPopOver(true);
                        }
                    }}
                >
                    <Card className={`${styles.root} ${styles['short-comment']}`} ref={cardRef}>
                        <CardHeader
                            avatar={(
                                <div>
                                    <AvatarCustom author={comment.Author} />
                                </div>
                            )}
                            // card action to display donation amount, style of action seems fit our design
                            action={(
                                <div>
                                    <div className={styles.row}>
                                        <div className={styles.amount}>
                                            {`$${comment.Amount}`}
                                        </div>
                                        <div className={`${styles.row} ${styles['created-text']}`}>{Utils.CalculateTimeDiff(comment.Created)}</div>
                                    </div>
                                </div>
                            )}
                            subheader={(
                                <div>
                                    <div className={`${styles['no-bottom-margin']} columns`}>
                                        <div className={`${styles.donor} ${styles['column']}`}>
                                            <p className={styles['truncate-single-line']}>
                                                {comment.Author || 'Anonymous'}
                                            </p>
                                        </div>
                                        <div className={`${styles['donated-to']} column`}>
                                            {' donated to'}
                                        </div>
                                    </div>
                                    <div className={styles.row}>
                                        <div className={styles.column}>
                                            <p className={styles['truncate-single-line']}>
                                                <a href={pageUrl} target={inIframe() ? '_parent' : '_self'} className={styles.organization} onClick={(e) => e.stopPropagation()}>
                                                    {targetName}
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        />
                        <CommentCardHeader className={`${styles.comment} `}>
                            <div ref={messageTextRef}>
                                <p className={styles['truncate-long-comment']}>{comment.MessageText}</p>
                            </div>
                            {canExpand && <MoreHorizIcon className={styles['more-icon']} fontSize="medium" />}
                        </CommentCardHeader>
                    </Card>
                </div>
            </div>
            <LongCommentPopover
                show={showPopOver}
                avatarSrc={avatarSrc}
                comment={comment}
                handleClose={() => setShowPopOver(false)}
                targetName={targetName}
                anchorEl={cardRef.current}
                isMobile={isMobile}
                key={comment.Key}
                pageUrl={pageUrl}
            />
        </>
    );
};

export default CommentCard;
